import React, { useCallback } from 'react';
import { Button, ButtonTheme } from '@apply/components';

export const ButtonDemo: React.FC<{}> = ({}) => {
    const buttonClick: React.MouseEventHandler = useCallback((event) => {
        alert(event.currentTarget.id + ' clicked.');
    }, []);

    return (
        <div style={{ marginTop: '0px', marginBottom: '20px' }}>
            <h2>Button :</h2>
            <br />
            <Button
                id='primaryButton'
                theme={ButtonTheme.Primary}
                width='314px'
                handleClick={buttonClick}
            >
                New Application
            </Button>
            <br />
            <br />
            <Button
                id='primaryButton-disabled'
                theme={ButtonTheme.Primary}
                width='314px'
                handleClick={buttonClick}
                disabled={true}
            >
                New Application (Disabled)
            </Button>
            <br />
            <br />
            <Button
                id='secondaryButton'
                theme={ButtonTheme.Secondary}
                width='192px'
                handleClick={buttonClick}
            >
                Request Draw
            </Button>
            <br />
            <br />
            <Button
                id='secondaryButton-disabled'
                theme={ButtonTheme.Secondary}
                width='192px'
                handleClick={buttonClick}
                disabled={true}
            >
                Request Draw (Disabled)
            </Button>
            <br />
            <br />
            <Button
                id='tertiaryButton'
                theme={ButtonTheme.Tertiary}
                width='184px'
                handleClick={buttonClick}
            >
                Tertiary CTA
            </Button>
            <br />
            <br />
            <Button
                id='tertiaryButton-disabled'
                theme={ButtonTheme.Tertiary}
                width='184px'
                handleClick={buttonClick}
                disabled={true}
            >
                Tertiary CTA Disabled
            </Button>
            <br />
            <br />
            <Button
                id='declineButton'
                theme={ButtonTheme.Decline}
                width='334px'
                handleClick={buttonClick}
            >
                Decline
            </Button>
            <br />
            <br />
            <Button
                id='declineButton-disabled'
                theme={ButtonTheme.Decline}
                width='334px'
                handleClick={buttonClick}
                disabled={true}
            >
                Decline Disabled
            </Button>
            <br />
            <br />
            <Button
                id='linkBlueButton'
                theme={ButtonTheme.LinkBlue}
                width='220px'
                handleClick={buttonClick}
            >
                Blue Link Theme
            </Button>
            <br />
            <br />
            <Button
                id='linkBlueButton-disabled'
                theme={ButtonTheme.LinkBlue}
                width='220px'
                handleClick={buttonClick}
                disabled={true}
            >
                Blue Link Theme Disabled
            </Button>
            <br />
            <br />
            <Button
                id='linkRedButton'
                theme={ButtonTheme.LinkRed}
                width='220px'
                handleClick={buttonClick}
            >
                Red Link Theme
            </Button>
            <br />
            <br />
            <Button
                id='linkRedButton-disabled'
                theme={ButtonTheme.LinkRed}
                width='220px'
                handleClick={buttonClick}
                disabled={true}
            >
                Red Link Theme Disabled
            </Button>
            <br />
            <br />
            <Button
                id='choiceButton-enabled'
                theme={ButtonTheme.Choice}
                width='220px'
                handleClick={buttonClick}
                disabled={false}
            >
                <div>Choice Enabled</div>
            </Button>
            <br />
            <br />
            <Button
                id='choiceButton-disabled'
                theme={ButtonTheme.Choice}
                width='220px'
                handleClick={buttonClick}
                disabled={true}
            >
                <div>Choice Disabled</div>
            </Button>
        </div>
    );
};
